import { defineMessages } from "react-intl";

const messages = defineMessages({
  addTag: {
    id: "settings.fileTags.addTag",
    defaultMessage: "Add tag",
    description: "Add tag button title",
  },
  addTags: {
    id: "settings.fileTags.addTags.title",
    defaultMessage: "Add tags",
    description: "Add tags input title",
  },
  cancel: {
    id: "settings.fileTags.button.cancel",
    defaultMessage: "Cancel",
    description: "Cancel button text",
  },
  description: {
    id: "settings.fileTags.description",
    defaultMessage: "Create and manage tags for files attached to records.",
    description: "Description of settings file tags page",
  },
  placeholder: {
    id: "settings.fileTags.addTags.placeholder",
    defaultMessage: "Enter tags...",
    description: "Add tags placeholder",
  },
  save: {
    id: "settings.fileTags.button.save",
    defaultMessage: "Save",
    description: "Save button text",
  },
  title: {
    id: "settings.fileTags.title",
    defaultMessage: "File Tags",
    description: "Title of settings file tags page",
  },
});

export default messages;
